<template>
  <section class="">
    <!-- <div class="md:w-6/12 mr-4"> -->
    <!-- <section> -->
    <!-- <div class="flex justify-between mb-8">
          <h5 class="text-gray-light text-md">
            Choose an Image from the Library
          </h5>
          <button
            type="button"
            class="h-6 px-4 text-green-light transition-colors duration-150 ring-green-light ring-1 rounded-full focus:outline-none hover:bg-green-light hover:text-white"
            @click="toggleModal"
          >
            See All
          </button>
        </div> -->
    <!-- <Modal
          v-model="modalShow"
          :title="'Select Photos'"
          :classStr="'max-w-xl'"
        >
          <div class="flex md:flex-row flex-col">
            Searchbox on top for mobile screens
            <div class="md:hidden mb-8">
              <span class="flex justify-between items-center">
                <h3 class="text-gray-dark font-bold">
                  Choose an Image from the Library
                </h3>
                <button
                  type="button"
                  class="text-gray-dark rounded-md p-1"
                  @click.prevent="toggleModal"
                >
                  <X :stroke="3" />
                </button>
              </span>

              <div class="relative text-gray-700 mt-3">
                <input
                  class="w-full h-10 pl-3 pr-8 text-base placeholder-gray-600 bg-gray-300 ring-1 ring-gray-300 rounded-full shadow-lg focus:outline-none"
                  type="search"
                  v-model="search"
                  @keyup="handleSearch"
                />
                <div
                  class="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none"
                >
                  <Search :height="16" :width="16" :stroke="4" />
                </div>
              </div>
            </div>

            <div class="rounded-l-md space-y-4 relative">
              <div class="flex items-center justify-between">
                <h6
                  class="text-sm font-semibold leading-normal mt-0 mb-0 text-gray-dark"
                >
                  Choose a photo as your thumbnail
                </h6>
                <div class="relative text-gray-700 w-1/2">
                  <input
                    class="w-full h-8 pl-3 pr-8 text-base placeholder-gray-600 ring-1 ring-gray-300 rounded-full"
                    type="search"
                    placeholder="Search..."
                    v-model="search"
                    @keyup="handleSearch"
                  />
                  <div
                    class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none"
                  >
                    <Search :height="16" :width="16" />
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-5 grid-cols-2 gap-4">
                <div v-for="d in imagesData" :key="d.id">
                  <div class="bg-gray-300 h-24 w-24 rounded-md object-cover">
                    <button
                      type="button"
                      class="focus:shadow-outline"
                      @click="handleModalThumbnailSelected(d)"
                      :class="
                        modalThumbnailSelected == d
                          ? 'ring-1 ring-gray-300 rounded-md'
                          : ''
                      "
                    >
                      <img
                        class="h-24 w-24 rounded-md object-cover"
                        :src="d.url"
                        alt=""
                        onerror="this.style.display='none'"
                      />
                    </button>
                  </div>
                </div>
                <p
                  class="text-sm text-gray-light"
                  v-if="imagesData.length === 0"
                >
                  No data found.
                </p>
              </div>
              <div class="flex items-center justify-between">
                <PaginationComponent
                  v-if="imagesData.length"
                  :currentPage="pagination.current_page"
                  :handlePageChange="handlePageChange"
                  :totalPages="pagination.last_page"
                />
                <div class="flex items-center space-x-2">
                  <button
                    type="button"
                    class="h-8 px-4 text-sm text-gray-dark transition-colors duration-150 rounded-lg focus:shadow-outline"
                    @click="toggleModal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="h-8 px-4 text-sm text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline"
                    @click="handleApply"
                  >
                    Select Image
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal> -->
    <!-- <div class="md:mt-2 mt-8">
          <div class="grid lg:grid-cols-5 md:grid-cols-3 gap-10 grid-cols-3">
            <div v-for="(d, i) in sessionCategoryImages" :key="i">
              <div class="bg-gray-300 h-20 w-20 rounded-md mb-8">
                <button
                  type="button"
                  @click="handleSupportingSelected(d.url, d.id)"
                  class="rounded-md"
                  :class="{
                    'outline-black': supportingImage === d.url,
                    'outline-black':
                      details &&
                      details[0] &&
                      details[0].unsplash_image_id === d.id,
                  }"
                >
                  <img
                    class="h-20 w-20 object-cover rounded-md"
                    :src="d.url"
                    alt=""
                    onerror="this.style.display='none'"
                  />
                </button>
              </div>
            </div>
          </div>
        </div> -->
    <!-- </section> -->
    <!-- <section class="mb-8"> -->
    <!-- <div class="flex justify-between mb-8">
          <h5 class="text-gray-light text-md">
            OR Upload an Image from your System
          </h5>

          <button
            type="button"
            class="h-6 px-4 text-green-light transition-colors duration-150 ring-green-light ring-1 rounded-full focus:outline-none hover:bg-green-light hover:text-white"
            @click="$refs.imgDropZone.$el.click()"
          >
            Browse
          </button>
        </div> -->
    <!-- </section> -->
    <!-- <section class="ring-dashed ring-1 ring-gray-300 rounded-lg">
        <vue2Dropzone
          ref="imgDropZone"
          id="customdropzone"
          :options="dropzoneOptions"
          @vdropzone-complete="handleComplete"
        ></vue2Dropzone>

        <div v-if="supportingImage.length > 0">
          <div v-for="d in supportingImage" :key="d.id">
            <img
              :src="d.data"
              onerror="this.style.display='none'"
              class="object-cover"
            />
          </div>
        </div>
      </section> -->
    <!-- </div> -->
    <ThumbnailModal
      v-if="isModalOpen"
      :isModalOpenProp="isModalOpen"
      :tabSelection="tab"
      @sessionImage="createSessionImage"
      @cancelModal="toggleModal"
    />
    <div class="grid grid-cols-12 gap-4">
      <section class="md:col-span-6 col-span-12">
        <div v-if="thumbnailPreview">
          <Cropper
            ref="cropper"
            class="twitter-cropper"
            background-class="twitter-cropper__background"
            foreground-class="twitter-cropper__foreground"
            image-restriction="stencil"
            default-boundaries="fill"
            :stencil-size="stencilSize"
            :stencil-props="{
              handlers: {},
              movable: false,
              scalable: false,
              aspectRatio: 5 / 3, // default 1
              previewClass: 'twitter-cropper__stencil',
            }"
            :transitions="false"
            :canvas="true"
            :debounce="false"
            :default-size="defaultSize"
            :min-width="150"
            :min-height="150"
            :src="thumbnailPreview"
            @change="onChange"
          />
          <div class="mb-4"></div>
          <Navigation
            :zoom="zoom"
            @change="onZoom"
            @zoomInBtn="zoomIn"
            @zoomOutBtn="zoomOut"
          />
        </div>
        <div v-else>
          <div
            class="h-80 bg-gray-100 rounded-lg flex flex-col justify-center items-center border mb-4"
            :class="{ 'border-red-700': !showAlertCircleIcon }"
            title="Thumbnail Image Required"
          >
            <svg style="width: 60px; height: 60px" viewBox="0 0 24 24">
              <path
                fill="grey"
                d="M7,15L11.5,9L15,13.5L17.5,10.5L21,15M22,4H14L12,2H6A2,2 0 0,0 4,4V16A2,2 0 0,0 6,18H22A2,2 0 0,0 24,16V6A2,2 0 0,0 22,4M2,6H0V11H0V20A2,2 0 0,0 2,22H20V20H2V6Z"
              />
            </svg>
            <div class="flex flex-col text-center">
              <span class="mt-4 text-gray-light flex flex-row items-center">
                Click&nbsp;
                <div
                  class="bg-gray-250 h-4 w-4 rounded-sm flex justify-center items-center border"
                >
                  <svg class="cursor-default" style="width: 52px; height: 52px" viewBox="0 0 24 24">
                    <path
                      fill="white"
                      d="M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z"
                    />
                  </svg>
                </div>
                &nbsp;to upload Supporting Images
              </span>
              <span class=" text-gray-light">
                OR
              </span>
              <span class=" text-gray-light">
                Choose from the <span class="underline text-green-light cursor-pointer" @click="toggleModalHandler('library')">Library</span> 
              </span>
            </div>
          </div>
          <p class="text-red-700 text-xs" v-if="!showAlertCircleIcon">
            Thumbnail Image is required.
          </p>
          <Navigation
            :zoom="zoom"
            @change="onZoom"
            @zoomInBtn="zoomIn"
            @zoomOutBtn="zoomOut"
          />
        </div>
      </section>
      <div class="md:col-span-4 col-span-12">
        <div v-if="supportingPreview">
          <div class="flex md:flex-col flex-row flex-wrap">
            <div
              class="relative mb-4 mr-4"
              v-for="(d, index) in supportingPreview"
              :key="index"
            >
              <div class="bg-gray-300 h-20 w-20 rounded-md">
                <button
                  type="button"
                  class="focus: outline-none"
                  @click="handleSupportingSelected(d)"
                >
                  <img
                    class="rounded-md h-20 w-20 object-cover"
                    :src="d"
                    alt=""
                    onerror="this.style.display='none'"
                  />
                </button>
                <button
                  type="button"
                  class="absolute"
                  @click="handleSupportingRemove(index)"
                >
                  <XCircle />
                </button>
              </div>
            </div>
            <div class="mb-4 mr-4" v-for="d in 4 - supportingPreview.length" :key="d.id">
              <div
                class="bg-gray-250 h-20 w-20 rounded-md flex justify-center items-center border"
                title="Thumbnail Image Required"
                @click="toggleModalHandler('library')"
              >
                <svg style="width: 52px; height: 52px" viewBox="0 0 24 24">
                  <path
                    fill="white"
                    d="M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z"
                  />
                </svg>
              </div>
            </div>
          </div>
          <p
            class="text-xs text-red-700"
            v-if="!isSupportingImageValid && 2 > supportingImage.length"
          >
            Supporting Images are required (Minimum of 2).
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Navigation from "@/components/cropper/Navigation";
// import { Modal, PaginationComponent } from "@/components/t-components";
import {
  XCircle,
  // Search, X, Plus,
} from "@/components/icons";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import ThumbnailModal from "@/components/modals/ThumbnailModal.vue";

export default {
  name: "SessionSupportingImages",
  components: {
    Cropper,
    // vue2Dropzone,
    // Modal,
    // PaginationComponent,
    XCircle,
    Navigation,
    // Search,
    // X,
    // Plus,
    ThumbnailModal,
  },
  props: {
    src: File,
    supportingImages: Array,
    // categoryId: String,
    isSupportingImageValid: Boolean,
    showAlertCircleIcon: Boolean,
    details: Array,
    // thumbnailImageProp: File,
    // thumbnailImageId: [String, Number],
  },
  data() {
    return {
      // dropzoneOptions: {
      //   url: "https://httpbin.org/post",
      //   thumbnailWidth: 100,
      //   thumbnailHeight: 100,
      //   addRemoveLinks: false,
      //   maxFiles: 4,
      //   acceptedFiles: ".jpg, .jpeg, .png",
      //   dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
      //     <p class="form-text">Allowed Files: .jpg, .jpeg, .png</p>
      //     `,
      // },
      isModalOpen: false,
      // thumbnailImage: "",
      thumbnailPreview: "",
      supportingImage: [],
      supportingPreview: [],
      // imagesData: [],
      // sessionCategoryImages: [],
      // search: "",
      // thumbnailPreviewId: "",
      // dataURL: "",
      // pagination: {},
      // modalThumbnailPreview: "",
      zoom: 0,
      tab: 'upload'
      // modalThumbnailSelected: "",
      // totalPages: "",
      // currentPage: 1,
      // categoryId: "Fitness",
    };
  },
  computed: {
    ...mapGetters([
      // "images",
      "trainerSessionView",
    ]),

    // imagesSearch() {
    //   return this.images;
    // },
  },
  watch: {
    supportingImage(files) {
      files && files.length === 0 ? this.thumbnailPreview = '' : ''
    }
  },
  methods: {
    ...mapActions([
      // "getImages",
      // "getSessionImages",
      // , "getImagesSearch"
      "getTrainerSessionView",
    ]),

    blobToFile(blob) {
      return new File([blob], `my_image${new Date()}.jpeg`);
    },
    toggleModalHandler (tab) {
      tab ? this.tab = tab : ''
      this.toggleModal()
    },
    // cropper change
    onChange() {
      const cropper = this.$refs.cropper;
      if (cropper) {
        if (cropper.imageSize.height < cropper.imageSize.width) {
          this.zoom =
            (cropper.imageSize.height - cropper.coordinates.height) /
            (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
        } else {
          this.zoom =
            (cropper.imageSize.width - cropper.coordinates.width) /
            (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
        }
      }
      const { canvas } = this.$refs.cropper.getResult();
      if (canvas) {
        canvas.toBlob((blob) => {
          if (this.thumbnailPreviewId) {
            this.supportingImage.map((d, i) => {
              if (d.id == this.thumbnailPreviewId) {
                this.supportingImage[i] = this.blobToFile(blob);
              }
            });
            this.$emit("supporting-image", this.supportingImage);
          } else {
            // this.thumbnailImage = this.blobToFile(blob);
            // this.$emit("thumbnail-image", this.thumbnailImage);
          }
        }, "image/jpeg");
      } else {
        console.log("canvas is not defined");
      }
    },

    // cropper stencil-size
    stencilSize({ boundaries }) {
      return {
        width: Math.min(boundaries.height, boundaries.width),
        height: Math.min(boundaries.height, boundaries.width),
      };
    },

    // cropper default-size
    defaultSize({ imageSize }) {
      return {
        width: Math.max(imageSize.height, imageSize.width),
        height: Math.max(imageSize.height, imageSize.width),
      };
    },

    // navigation change
    onZoom(value) {
      const cropper = this.$refs.cropper;
      if (cropper) {
        if (cropper.imageSize.height < cropper.imageSize.width) {
          const minHeight = cropper.sizeRestrictions.minHeight;
          cropper.zoom(
            ((1 - this.zoom) * cropper.imageSize.height + minHeight) /
              ((1 - value) * cropper.imageSize.height + minHeight)
          );
        } else {
          const minWidth = cropper.sizeRestrictions.minWidth;
          cropper.zoom(
            ((1 - this.zoom) * cropper.imageSize.width + minWidth) /
              ((1 - value) * cropper.imageSize.width + minWidth)
          );
        }
      }
    },

    zoomIn(value) {
      value += 0.011;

      this.onZoom(value);
    },

    zoomOut(value) {
      value -= 0.011;

      this.onZoom(value);
    },

    // handleThumbnailPreview(file) {
    //   var reader = new FileReader();

    //   reader.onload = (e) => {
    //     this.thumbnailPreview = e.target.result;
    //   };
    //   reader.readAsDataURL(file);
    // },

    // handleModalThumbnailSelected(d) {
    //   this.sessionCategoryImages.forEach((el, index) => {
    //     if (d.id == el.id) {
    //       this.sessionCategoryImages.splice(index, 1);
    //     }
    //   });
    //   this.thumbnailPreviewId = "";
    //   this.modalThumbnailPreview = d.url;
    //   if (this.details && this.details[0] && this.details[0].unsplash_image_id)
    //     this.details[0].unsplash_image_id = d.id;
    //   this.modalThumbnailSelected = d;
    //   this.$emit("thumbnail-id", d.id);
    // },

    // handleApply() {
    //   this.thumbnailPreview = this.modalThumbnailPreview;
    //   this.isModalOpen = !this.isModalOpen;
    //   const categoryImages = [...this.sessionCategoryImages];

    //   if (this.modalThumbnailSelected) {
    //     categoryImages.pop();
    //     categoryImages.unshift(this.modalThumbnailSelected);
    //     this.sessionCategoryImages = categoryImages;
    //   }
    // },

    toggleModal() {
      this.isModalOpen = !this.isModalOpen;
    },

    async handleSupportingSelected(str, id) {
      if (this.supportingImage && this.supportingImage.length > 3) {
        // alert("You cannot upload anymore files.");
        this.$store.commit('setError', {title: "Alert", text: "You cannot upload anymore files."})
        return;
      }
      // this.thumbnailPreviewId = "";
      this.thumbnailPreview = str;
      await axios
        .post("image-blob", {
          image_url: str,
        })
        .then((res) => {
          const file = new File([res.data.data.content], "filename.jpg", {
            type: "image/jpeg",
          });
          var reader = new FileReader();

          reader.readAsDataURL(file);
          reader.onload = (e) => {
            // const index = this.supportingImage.findIndex(
            //   (obj) => obj.id === id
            // );
            // if (index > -1) {
            //   this.supportingImage.splice(index, 1);
            // }
            // this.supportingImage.push(file);
          };
          // this.handlesupportingImage(file, id);
          // this.supportingImage.push({ data: file, id: id });
          // this.$emit("supporting-image", this.supportingImage);
        })
        .catch((e) => console.log(e));
      // console.log("emit thumbnail-id");
      // this.$emit("thumbnail-id", id);
    },

    // handleSupportingPreview(file, id = null) {
    //   var reader = new FileReader();
    //   reader.onload = (e) => {
    //     this.supportingImage.push({
    //       id: id ? id : this.supportingImage.length + 1,
    //       file: file,
    //       result: e.target.result,
    //     });
    //   };
    //   reader.readAsDataURL(file);
    // },

    // handleUploadedSelected(str, id) {
    //   this.thumbnailPreviewId = id;
    //   this.thumbnailPreview = str;
    // },

    // handlesupportingImage(file, id) {
    //   var reader = new FileReader();

    //   reader.onload = (e) => {
    //     this.supportingImage.push({
    //       id: id ? id : this.supportingImage.length + 1,
    //       file: file,
    //       result: e.target.result,
    //     });
    //     this.thumbnailPreview = e.target.result;
    //   };
    //   reader.readAsDataURL(file);
    // },

    async createSessionImage(file) {
      if (file && file.name && /\.(jpe?g|png|gif)$/i.test(file.name)) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          this.supportingPreview.push(e.target.result);
          this.thumbnailPreview = e.target.result;
        };
        this.supportingImage.push(file);
        this.$emit("supporting-image", this.supportingImage);
      } else {
        var image_url = file;
        fetch(image_url)
          .then((r) => r.blob())
          .then((res) => {
            let newfile = new File([res], "filename", {
              type: res.type,
            });
            var newreader = new FileReader();
            newreader.readAsDataURL(newfile);
            newreader.onload = (e) => {
              this.supportingPreview.push(e.target.result);
            };
            this.supportingImage.push(newfile);
            this.$emit("supporting-image", this.supportingImage);
          })
          .catch((e) => console.log(e));
      }
    },

    handleSupportingRemove(id) {
      const index = this.supportingImage.findIndex((e, i) => i === id);
      if (index !== -1) {
        this.supportingImage.splice(index, 1);
        this.supportingPreview.splice(index, 1);
      }

      //also remove image from the supportingImage on image where user clicked (x).
      // const i = this.supportingImages.findIndex((e) => e.id === id);
      // if (i !== -1) {
      //   this.supportingImages.splice(i, 1);
      // }

      // const ind = this.supportingImage.findIndex((e) => e.id === id);
      // if (ind !== -1) {
      //   this.supportingImage.splice(ind, 1);
      // }
      // this.supportingImage = [];
      // this.supportingPreview = [];
      this.$emit("remove-supporting-image", this.supportingImage);
    },

    // async handleSearch() {
    //   let timeout = null;
    //   clearTimeout(timeout);
    //   timeout = setTimeout(() => {
    //     this.categoryId = this.search;
    //     this.getImagesSearch(this.categoryId);
    //   }, 1000);
    // },

    // async handleComplete(upload) {
    //   if (this.supportingImage && this.supportingImage.length > 3) {
    //     alert("You cannot upload anymore files.");
    //     this.$refs.imgDropZone.removeFile(upload);
    //     return;
    //   }
    //   try {
    //     let file = upload;
    //     this.handlesupportingImage(file);
    //     this.supportingImages.push({
    //       data: file,
    //       id: this.supportingImage.length + 1,
    //     });
    //     this.$emit("supporting-image", this.supportingImage);
    //   } catch (e) {
    //     console.log(e);
    //   }
    //   this.$refs.imgDropZone.removeFile(upload);
    // },

    // async handlePageChange(page) {
    //   this.currentPage = page;
    //   this.imagesData = [];
    //   axios
    //     .get(`get/images/${this.categoryId}/15?page=${this.currentPage}`)
    //     .then((res) => {
    //       this.imagesData = res.data.data.data || [];
    //       this.pagination.current_page = res.data.data.current_page;
    //       this.pagination.last_page = res.data.data.total_pages;
    //     });
    // },

    async thumbnailUrlBlob(file) {
      if (file && file.name && /\.(jpe?g|png|gif)$/i.test(file.name)) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          this.supportingPreview.push(e.target.result);
        };
        this.supportingImage.push(file);
        this.$emit("supporting-image", this.supportingImage);
      } else {
        var image_url = file;
        await axios
          .post("image-blob", {
            image_url: image_url,
          })
          .then((res) => {
            fetch(res.data.data.content)
              .then((response) => response.blob())
              .then((blob) => {
                let newfile = new File([blob], "filename", {
                  type: blob.type,
                });
                this.supportingPreview.push(res.data.data.content);
                this.thumbnailPreview = res.data.data.content;
                this.supportingImage.push(newfile);
                this.$emit("supporting-image", this.supportingImage);
              });
          })
          .catch((e) => console.log(e));
      }
    },
  },
  destroyed() {
    this.$destroy();
  },
  async created() {
    // await this.getSessionImages(this.categoryId);
    // this.sessionCategoryImages = this.images.data;
    // this.handlePageChange(1);
    if (typeof this.$route.params.id != "undefined") {
      await this.getTrainerSessionView({ id: this.$route.params.id });
      this.trainerSessionView &&
        this.trainerSessionView.supporting_images.forEach((el) => {
          if (el.thumbnail_url) {
            this.thumbnailUrlBlob(this.baseUrlSrc(el.thumbnail_url));
          }
        });
    }
    //supporting images
    // this.supportingImages &&
    //   this.supportingImages.forEach((el) => {
    //     if (el.thumbnail_url) {
    //       this.thumbnailUrlBlob(this.baseUrlSrc(el.thumbnail_url));
    //     }
    //  else if (!el.thumbnail_url) {
    //   this.handleSupportingPreview(el.data, el.id);
    // }
    // });
    // if (this.supportingImages) this.supportingImage = this.supportingImages;
    //thumbnail image
    // if (this.src) {
    //   this.handleThumbnailPreview(this.src);
    // }
    // console.log("emit handleFileProps");
    // this.$emit("handleFileProps", this.thumbnailPreview);
  },
};
</script>

<style scoped>
/* .outline-black {
  outline-style: solid;
  outline-color: black;
  outline-width: medium;
} */
.twitter-cropper {
  height: 360px;
  width: 600px;
}
.twitter-cropper__background {
  background-color: #edf2f4;
}
.twitter-cropper__foreground {
  background-color: #edf2f4;
}
.twitter-cropper__stencil {
  border: solid 5px #1da1f2;
}
@media only screen and (max-width: 420px) {
  .twitter-cropper {
    height: 300px;
  }
}
</style>